let deviceInfo

export function setDeviceInfo(deviceInfoFunc){
	deviceInfo = deviceInfoFunc
}

export default function(){
	if(!deviceInfo){
		throw new Error('Call setDeviceInfo first')
	}
	return deviceInfo
}



// WEBPACK FOOTER //
// ./node_modules/mb-app-common/lib/shim/deviceInfo.js